'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _withPadding = require('./with-padding');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withPadding).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }